<!--  -->
<template>
  <div class="monthly-man">
    <div id="monthly" class="monthlyStyle"></div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  name: "monthly-man",
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let monthly = this.$echarts.init(document.getElementById("monthly"));

      app.title = "多 X 轴示例";

      var colors = ["#5793f3", "#d14a61", "#675bba"];

      // 绘制图表
      monthly.setOption({
        color: colors,

        tooltip: {
          trigger: "none",
          axisPointer: {
            type: "cross"
          }
        },
        legend: {
          top: 14,
          left: 100,
          textStyle: {
            color: "#ffffff"
          },
          data: ["企业管理员", "个人用户"]
        },
        grid: {
          top: 70,
          bottom: 50
        },
        xAxis: [
          {
            type: "category",
            axisTick: {
              alignWithLabel: true
            },
            axisLine: {
              onZero: false,
              lineStyle: {
                color: "#ffffff"
              }
            },
            axisPointer: {
              label: {
                formatter: function(params) {
                  return (
                    "新增数量  " +
                    params.value +
                    (params.seriesData.length
                      ? "：" + params.seriesData[0].data
                      : "")
                  );
                }
              }
            },
            data: [
              "2016-1",
              "2016-2",
              "2016-3",
              "2016-4",
              "2016-5",
              "2016-6",
              "2016-7",
              "2016-8",
              "2016-9",
              "2016-10",
              "2016-11",
              "2016-12"
            ],
            axisLine: {
              onZero: false,
              lineStyle: {
                color: "#67ebff",
                width: 1
              }
            }
          },
          {
            type: "category",
            axisTick: {
              alignWithLabel: true
            },
            axisLine: {
              // onZero: false,
              lineStyle: {
                color: "#67ebff"
              }
            },
            axisPointer: {
              label: {
                formatter: function(params) {
                  return (
                    "新增数量  " +
                    params.value +
                    (params.seriesData.length
                      ? "：" + params.seriesData[0].data
                      : "")
                  );
                }
              }
            }
          }
        ],
        yAxis: {
          axisLine: {
            onZero: false,
            lineStyle: {
              color: "#67ebff",
              width: 1
            }
          },
          splitLine: {
            //网格线
            lineStyle: {
              color: "#67EEFF",
              type: "dashed" //设置网格线类型 dotted：虚线   solid:实线
            },
            show: true //隐藏或显示
          }
        },
        series: [
          {
            lineStyle: {
              normal: {
                color: "#F25357"
              }
            },
            color: "#F25357",
            name: "企业管理员",
            type: "line",
            xAxisIndex: 1,
            smooth: true,
            data: [
              2.6,
              5.9,
              9.0,
              26.4,
              28.7,
              70.7,
              175.6,
              182.2,
              400,
              48.7,
              18.8,
              6.0,
              2.3
            ]
          },
          {
            lineStyle: {
              normal: {
                color: "#4dc9a2"
              }
            },
            color: "#4dc9a2",
            name: "个人用户",
            type: "line",
            smooth: true,
            data: [
              3.9,
              5.9,
              11.1,
              18.7,
              48.3,
              69.2,
              231.6,
              46.6,
              55.4,
              18.4,
              10.3,
              0.7
            ]
          }
        ]
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.drawLine();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.monthlyStyle {
  margin-top: 30px;
  width: 100%;
  height: 70%;
}
</style>
